import { ScheduleModel } from '@maxpreps/apiserviceclients/apiModels';
import useRequestContext from '@maxpreps/shared/contexts/RequestContext';
import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import Anchor from '@maxpreps/shared/corecomponents/Anchor/Anchor';
import { Tablet } from '@maxpreps/shared/corecomponents/ScreenSize/ScreenSize';
import THEME from '@maxpreps/shared/styles/colors';
import styled from 'styled-components';
import getCSRRewriteAttributes from '../../../utils/getCSRRewriteAttributes';
import { getTeamUrl } from './../../../utils/navigation';
import { Page } from './../../../utils/pages';

interface IBackToPublicBannerProps {
  pageKey: Page;
}

const StyledBackToPublicBanner = styled.div`
  width: 100%;
  height: 55px;
  background-color: ${THEME.surface.information};

  white-space: nowrap;

  display: flex;
  align-items: center;
  justify-content: center;

  .stuck & {
    box-shadow: 0 8px 8px 0 ${THEME.shadow.light};
  }
  span,
  b {
    margin-right: 6px;
  }
  a {
    text-decoration: underline;
  }
`;

const BackToPublicBanner: React.FC<IBackToPublicBannerProps> = ({
  pageKey
}) => {
  const teamContext = useTeamContext();
  const { appType } = useRequestContext();

  const { data, mostRecentPublicGenderSportSeasonLevel } = teamContext;

  const { teamId } = data;

  const { scheduleModel: scheduleModelKey } =
    teamContext.sportData as never as {
      scheduleModel: keyof ScheduleModel;
    };

  // since were ALWYAS linking tot he most recent public ss
  // we should always have a team home url here :)
  // BUT if we want to try to keep the link contextual we need to
  // manage this a bit more. Custom sports don't have a schedule
  // page in react so we don't want to create a CSR link
  // if (
  //   isPage(
  //     mostRecentPublicGenderSportSeasonLevel?.canonicalUrl,
  //     schedulePageTest
  //   )
  // ) {
  //   return null;
  // }

  const anchorAttrs = getCSRRewriteAttributes(
    getTeamUrl(pageKey, mostRecentPublicGenderSportSeasonLevel.canonicalUrl),
    teamId,
    mostRecentPublicGenderSportSeasonLevel.sportSeasonId,
    mostRecentPublicGenderSportSeasonLevel.allSeasonId,
    appType,
    undefined,
    ScheduleModel[scheduleModelKey]
  );

  return (
    <StyledBackToPublicBanner>
      <span className="top">
        You are in <b>Admin View.</b>
        <Tablet andAbove>Want to preview your public page?</Tablet>
      </span>

      <Anchor {...anchorAttrs}>View As Public.</Anchor>
    </StyledBackToPublicBanner>
  );
};

export default BackToPublicBanner;
